import clsxm from "immigram-ui-cmon/src/lib/clsxm";
import { ChangeEvent, MouseEvent, ReactNode, useId } from "react";
import { useCallback } from "react";

import { Icon24Check } from "../Icons";
import { Icon24Lock, Icon24Unlock } from "../Icons";

interface CheckboxProps {
  className?: string;
  label?: ReactNode;
  description?: ReactNode;
  name: string;
  value: string | number;
  checked: boolean;
  onClick?: (event: MouseEvent) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  checkboxClass?: string;
  disabled?: boolean;
  onDisabledToggle?: (value: boolean) => void;
  withLabel?: boolean;
}

const Checkbox = (props: CheckboxProps) => {
  const id = useId();
  const { disabled, onDisabledToggle } = props;

  const handleDisabledToggle = useCallback(() => {
    onDisabledToggle?.(!disabled);
  }, [onDisabledToggle, disabled]);

  const withLabel = props.withLabel ?? true;

  return (
    <div
      className={clsxm(
        "items-top relative flex justify-between gap-x-2.5 overflow-hidden",
        props.className
      )}
    >
      <div className="flex gap-x-2.5">
        <input
          type="checkbox"
          id={id}
          name={props.name}
          disabled={props.disabled}
          value={props.value}
          checked={props.checked}
          className="peer absolute h-8 w-8 cursor-pointer opacity-0"
          onClick={props.onClick}
          onChange={(event) => {
            props.onChange?.(event);
          }}
        />
        <div
          className={clsxm(
            "bg-white flex h-6 w-6 flex-shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-md border-none bg-gray-100 transition-all focus-within:border-black-900 peer-checked:bg-black-900",
            props.checkboxClass
          )}
        ></div>
        <Icon24Check className="pointer-events-none absolute top-0 left-0 hidden cursor-pointer fill-white-900 text-white-900 peer-checked:block" />

        {props.label !== undefined && (
          <div className="flex flex-col overflow-hidden">
            <label
              className={clsxm(
                "cursor-pointer select-none text-ellipsis text-base text-black-900",
                props.className
              )}
              htmlFor={withLabel ? id : undefined}
            >
              {props.label}
            </label>
            {props.description !== undefined && (
              <div className="pt-0.5 text-sm text-black-600">
                {props.description}
              </div>
            )}
          </div>
        )}
      </div>
      {(disabled || onDisabledToggle) && (
        <div className="z-10 inline-flex min-h-full">
          {onDisabledToggle ? (
            <>
              {disabled ? (
                <Icon24Lock
                  className="text-black-400"
                  onClick={handleDisabledToggle}
                />
              ) : (
                <Icon24Unlock
                  className="cursor-pointer text-black-400"
                  onClick={handleDisabledToggle}
                  active
                />
              )}
            </>
          ) : (
            <Icon24Lock className="text-black-400" disabled={true} />
          )}
        </div>
      )}
    </div>
  );
};

export default Checkbox;
